import React, { Component } from 'react';
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import { getRequestParams } from '../../helpers/globalfunctions.js';
import Swal from 'sweetalert2';
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';
const sizeValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
const fontValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];

export const mailPriorityDropdownList = [{
    'id': 0,
    'name': 'Normal',
}, {
    'id': 1,
    'name': 'Low',
}, {
    'id': 2,
    'name': 'High',
}]
export class SendEmailComponent extends Component {
    constructor() {
        super()
        this.state = {
            isSubmitted: false,
            isOpenModal: false,
            loadPanelVisible: false,
            isEmailBCc: false,
            emailTo: '',
            emailCc: '',
            emailBcc: '',
            emailSubject: '',
            emailBody: '',
            attachments: [],
            isSendAttachment: false,
            mailPriority: 0,
            fileNameDisplay: '',
            errors: {
                emailTo: '',
                emailCc: '',
                emailBcc: '',
                emailSubject: '',
            }
        }
    }
    showModal = async (emailTo, emailCc, emailSubject, emailBody, attachments) => {
        try {
            this.setState({ isOpenModal: true });
            this.setState({
                emailTo: emailTo,
                emailCc: emailCc,
                emailSubject: emailSubject,
                attachments: attachments,
                isSendAttachment: (attachments !== null && attachments.length !== 0)
            });

            let fileNameDisplay = '';
            if (attachments !== null && attachments.length !== 0) {
                attachments.forEach((file) => {
                    fileNameDisplay += (fileNameDisplay.trim().length === 0) ? file.fileName : ' , ' + file.fileName;
                });
            }
            this.setState({ fileNameDisplay: fileNameDisplay });

            if (emailBody === null || emailBody.trim() === '') {
                emailBody = 'Dear Customer,<br/>'
                emailBody += 'Thank you for choosing <u>' + sessionStorage.getItem("session_accountname") + '</u><br/>';
                emailBody += 'If you have any questions, please feel free to contact our customer service agents at ' + sessionStorage.getItem("session_email") + '<br/>';
                emailBody += 'We thank you for your business!'
            }
            this.setState({ emailBody: emailBody });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {
        try {
            this.setState({
                isSubmitted: false,
                isOpenModal: false,
                loadPanelVisible: false,
                isEmailBCc: false,
                emailTo: '',
                emailCc: '',
                emailBcc: '',
                emailSubject: '',
                emailBody: '',
                attachments: [],
                isSendAttachment: false,
                mailPriority: 0,
                fileNameDisplay: '',
                errors: {
                    emailTo: '',
                    emailCc: '',
                    emailBcc: '',
                    emailSubject: '',
                }
            });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnClearSearch = async () => {
        try {
            this.setState({
                isSubmitted: false,
                loadPanelVisible: false,
                isEmailBCc: false,
                emailTo: '',
                emailCc: '',
                emailBcc: '',
                emailSubject: '',
                emailBody: '',
                isSendAttachment: (this.state.attachments !== null && this.state.attachments.length !== 0),
                mailPriority: 0,
                errors: {
                    emailTo: '',
                    emailCc: '',
                    emailBcc: '',
                    emailSubject: '',
                }
            });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnInputChange = async (event) => {
        try {
            const target = event.target;
            const name = target.name;
            const value = (target.type === 'checkbox' || target.type === 'radio') ? target.checked : target.value;
            let errors = this.state.errors;
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            switch (name) {
                case 'emailTo':
                    errors.emailTo = '';
                    if (value.length < 501) {
                        //if (value.trim() !== '') {
                        //    let email = value.split(',');
                        //    if (email.length > 0) {
                        //        for (let i = 0; i < email.length; i++) {
                        //            if ((email[i]).trim() !== "") {
                        //                if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                        //                    errors.emailTo = "Please enter valid email.";
                        //                }
                        //            }
                        //        }
                        //    }
                        //}
                        this.setState({ emailTo: value })
                    }
                    break;
                case 'emailCc':
                    errors.emailCc = '';
                    if (value.length < 501) {
                        //if (value.trim() !== '') {
                        //    let email = value.split(',');
                        //    if (email.length > 0) {
                        //        for (let i = 0; i < email.length; i++) {
                        //            if ((email[i]).trim() !== "") {
                        //                if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                        //                    errors.emailCc = "Please enter valid email.";
                        //                }
                        //            }
                        //        }
                        //    }
                        //}
                        this.setState({ emailCc: value })
                    }
                    break;
                case 'emailBcc':
                    errors.emailBcc = '';
                    if (value.length < 501) {
                        //if (value.trim() !== '') {
                        //    let email = value.split(',');
                        //    if (email.length > 0) {
                        //        for (let i = 0; i < email.length; i++) {
                        //            if ((email[i]).trim() !== "") {
                        //                if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                        //                    errors.emailBcc = "Please enter valid email.";
                        //                }
                        //            }
                        //        }
                        //    }
                        //}
                        this.setState({ emailBcc: value })
                    }
                    break;
                case 'emailSubject':
                    errors.emailSubject = '';
                    if (value.length < 151) {
                        this.setState({ emailSubject: value });
                    }
                    break;
                case 'emailBody':
                    if (value.length < 501) {
                        this.setState({ emailBody: value });
                    }
                    break;
                case 'isSendAttachment':
                    this.setState({ isSendAttachment: value });
                    break;
                case 'mailPriority':
                    this.setState({ mailPriority: value });
                    break;
                default:
                    break;
            }
            this.setState({ errors: errors });
        } catch (ex) {
            console.log(ex);
        }
    }
    isFormValid = async () => {
        let isValid = true;
        try {
            let errors = this.state.errors;
            errors.emailTo = '';
            errors.emailCc = '';
            errors.emailBcc = '';
            errors.emailSubject = '';
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (this.state.emailTo.trim() === '') {
                isValid = false;
                errors.emailTo = "Please enter email.";
            }
            if (this.state.emailTo.trim() !== '') {
                let email = this.state.emailTo.split(',');
                if (email.length > 0) {
                    for (let i = 0; i < email.length; i++) {
                        if ((email[i]).trim() !== "") {
                            if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                                isValid = false;
                                errors.emailTo = "Please enter valid email.";
                            }
                        }
                    }
                }
            }
            if (this.state.emailCc.trim() !== '') {
                let email = this.state.emailCc.split(',');
                if (email.length > 0) {
                    for (let i = 0; i < email.length; i++) {
                        if ((email[i]).trim() !== "") {
                            if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                                isValid = false;
                                errors.emailCc = "Please enter valid email.";
                            }
                        }
                    }
                }
            }
            if (this.state.emailBcc.trim() !== '') {
                let email = this.state.emailBcc.split(',');
                if (email.length > 0) {
                    for (let i = 0; i < email.length; i++) {
                        if ((email[i]).trim() !== "") {
                            if (!regEmail.test(String(email[i].trim()).toLowerCase())) {
                                isValid = false;
                                errors.emailBcc = "Please enter valid email.";
                            }
                        }
                    }
                }
            }
            if (this.state.emailSubject.trim() === '') {
                isValid = false;
                errors.emailSubject = "Please enter subject.";
            }
            this.setState({ errors: errors });
        } catch (ex) {
            isValid = false;
            console.log(ex);
        }
        return isValid;
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (await this.isFormValid()) {
                this.setState({ isSubmitted: true });
                let fileGuid = [];
                var request = new Object();
                if (this.state.isSendAttachment === true) {
                    if (this.state.attachments !== null && this.state.attachments.length !== 0) {
                        for (var i = 0; i < this.state.attachments.length; i++) {
                            request = new Object();
                            request.FileData = this.state.attachments[i].fileData;
                            request.FileName = this.state.attachments[i].fileName;
                            request.Extension = this.state.attachments[i].fileExtension;
                            let requestFileParams = getRequestParams('POST', request);
                            let responseFile = await fetch('report-api/upload-notification-attachment', requestFileParams);
                            let dataResponseFile = await responseFile.json();
                            if (dataResponseFile.isSuccess) {
                                fileGuid.push(dataResponseFile.fileGuid);
                            }
                        }
                    }
                }
                request = new Object();
                request.EmailTo = this.state.emailTo.trim();
                request.EmailCC = this.state.emailCc.trim();
                request.EmailBCC = this.state.emailBcc.trim();
                request.Subject = this.state.emailSubject.trim();
                request.Body = this.state.emailBody.toString('html');
                request.MobileNo = '';
                request.Header = '';
                request.Footer = '';
                request.NotificationTypeId = 1;
                request.NotificationPriority = Number(this.state.mailPriority);
                request.FileGuid = fileGuid;
                let requestParams = getRequestParams('POST', request);
                let response = await fetch('report-api/send-notification', requestParams);
                if (response.ok) {
                    const data = await response.json();
                    this.setState({ isSubmitted: false });
                    await Swal.fire({
                        allowOutsideClick: false,
                        icon: data.isSuccess ? 'success' : 'error',
                        title: data.isSuccess ? 'E-mail Sent' : 'Oops...',
                        text: data.isSuccess === false ? 'Unable to process the email request.' : 'The email request has been sent and will be received shortly.',
                        confirmButtonText: 'Thank you!',
                    }).then(async (result) => {
                        if (data.isSuccess) {
                            if (result.isConfirmed) {
                                await this.handleOnCloseModal();
                            }
                        }
                    })
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isSubmitted: false });
    }
    handleOnBodyChange = async (e) => {
        try {
            this.setState({ emailBody: e.value });
        } catch (ex) {
            console.log(ex);
        }
    }
    render() {
        const toolbarConfig = {
            // Optionally specify the groups to display (displayed in the order listed).
            display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
            INLINE_STYLE_BUTTONS: [
                { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
                { label: 'Italic', style: 'ITALIC' },
                { label: 'Underline', style: 'UNDERLINE' }
            ],
            BLOCK_TYPE_DROPDOWN: [
                { label: 'Normal', style: 'unstyled' },
                { label: 'Heading Large', style: 'header-one' },
                { label: 'Heading Medium', style: 'header-two' },
                { label: 'Heading Small', style: 'header-three' }
            ],
            BLOCK_TYPE_BUTTONS: [
                { label: 'UL', style: 'unordered-list-item' },
                { label: 'OL', style: 'ordered-list-item' }
            ]
        };
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '60%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form style={this.state.isSubmitted ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Send E-mail</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>To &nbsp;&nbsp;<i style={{ color: '#C04000' }}>( For more than one, enter a comma separated email address )</i></label>
                                        <input type="text" className="form-control form-control-sm"
                                            name="emailTo"
                                            placeholder="example@domain.com"
                                            title="To"
                                            value={this.state.emailTo}
                                            onChange={this.handleOnInputChange} />
                                        {this.state.errors["emailTo"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["emailTo"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>CC &nbsp;&nbsp;<i style={{ color: '#C04000' }}>( For more than one, enter a comma separated email address )</i></label>
                                        <input type="text" className="form-control form-control-sm"
                                            name="emailCc"
                                            placeholder="example@domain.com"
                                            title="Cc"
                                            value={this.state.emailCc}
                                            onChange={this.handleOnInputChange} />
                                        {this.state.errors["emailCc"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["emailCc"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12" style={{ display: (!this.state.isEmailBCc) || 'none' }}>
                                    <div className="form-group">
                                        <label className="btn-block" style={{ paddingTop: 7 + 'px' }}>&nbsp;</label>
                                        <button type="button" className="btn btn-custom-gray btn-sm" onClick={() => this.setState({ isEmailBCc: true })}>
                                            <i className="fas fa-plus"></i> BCC
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ display: this.state.isEmailBCc ? 'flex' : 'none' }}>
                                <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>BCC &nbsp;&nbsp;<i style={{ color: '#C04000' }}>( For more than one, enter a comma separated email address )</i></label>
                                        <input type="text" className="form-control form-control-sm"
                                            name="emailBcc"
                                            placeholder="example@domain.com"
                                            title="Bcc"
                                            value={this.state.emailBcc}
                                            onChange={this.handleOnInputChange} />
                                        {this.state.errors["emailBcc"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["emailBcc"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12" style={{ display: (this.state.isEmailBCc) || 'none' }}>
                                    <div className="form-group">
                                        <label className="btn-block" style={{ paddingTop: 7 + 'px' }}>&nbsp;</label>
                                        <button type="button" className="btn btn-custom-gray btn-sm" onClick={() => this.setState({ isEmailBCc: false, emailBcc: '' })}>
                                            <i className="fas fa-minus"></i> Hide
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label>Subject</label>
                                        <input type="text" className="form-control form-control-sm"
                                            name="emailSubject"
                                            placeholder=""
                                            title="Subject"
                                            value={this.state.emailSubject}
                                            onChange={this.handleOnInputChange} />
                                        {this.state.errors["emailSubject"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["emailSubject"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="form-group">
                                        <label>Mail Priority</label>
                                        <select name="mailPriority" className="form-control form-control-sm"
                                            value={this.state.mailPriority} onChange={this.handleOnInputChange}>
                                            {
                                                mailPriorityDropdownList &&
                                                mailPriorityDropdownList.map((item, i) =>
                                                    (<option key={i} value={item.id}>{item.name}</option>))
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={{ display: (this.state.fileNameDisplay.trim().length > 0) || 'none' }}>
                                    <div className="form-group">
                                        <label></label><br />
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox"
                                                name="isSendAttachment"
                                                checked={this.state.isSendAttachment}
                                                onChange={this.handleOnInputChange} />
                                            <label className="form-check-label" htmlFor="isSendAttachment"> Send Attachment</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                    <div className="form-group">
                                        <label></label><br />
                                        <label>
                                            <span style={{ display: (this.state.fileNameDisplay.trim().length > 0) || 'none' }} >
                                                <span style={{ display: this.state.isSendAttachment ? "block" : "none" }}>
                                                    <i className="fas fa-paperclip">{this.state.fileNameDisplay}</i> <br />
                                                </span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <HtmlEditor
                                            height={200}
                                            name="issuedetailsd"
                                            value={this.state.emailBody}
                                            valueType={"html"}
                                            onValueChanged={this.handleOnBodyChange}
                                        >
                                            <Toolbar>
                                                <Item name="undo" />
                                                <Item name="redo" />
                                                <Item name="separator" />
                                                <Item
                                                    name="size"
                                                    acceptedValues={sizeValues}
                                                />
                                                <Item
                                                    name="font"
                                                    acceptedValues={fontValues}
                                                />
                                                <Item name="separator" />
                                                <Item name="bold" />
                                                <Item name="italic" />
                                                <Item name="strike" />
                                                <Item name="underline" />
                                                <Item name="separator" />
                                                <Item name="alignLeft" />
                                                <Item name="alignCenter" />
                                                <Item name="alignRight" />
                                                <Item name="alignJustify" />
                                                <Item name="separator" />
                                                <Item name="color" />
                                                <Item name="background" />
                                            </Toolbar>
                                        </HtmlEditor>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" title="Send" onClick={this.handleOnSendEmail}>
                                {this.state.isSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmitted && <span title="Send"><i className="fas fa-paper-plane"></i> Send</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleOnClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleOnCloseModal}><i className="fas fa-times"></i> Cancel</button>
                        </div>
                    </form>
                </Modal>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={{ of: '#panelgrid' }}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        );
    }
}
